import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Network } from 'lucide-react';
import { useClient } from '../hooks/useClients.js';
import { useClientStore } from '../store/client.store.js';
import MpMap from '../components/MpMap/index.jsx';
import Spinner from '../components/Spinner.jsx';

export default function ClientMpMap() {
  const { id } = useParams();
  const { data: client, isLoading } = useClient(id);
  const { selectedClientId, setClient } = useClientStore();

  // Asegura que el cliente esté seleccionado en el store global para que MpMap lo tome
  useEffect(() => {
    if (client && selectedClientId !== client.id) {
      setClient({ id: client.id, code: client.code, name: client.business_name });
    }
  }, [client, selectedClientId, setClient]);

  if (isLoading) return <div className="flex justify-center py-10"><Spinner size="lg" /></div>;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Link to={`/clients/${id}`} className="text-slate-400 hover:text-white text-sm">
          ← {client?.business_name || 'Cliente'}
        </Link>
        <span className="text-slate-600">|</span>
        <div className="flex items-center gap-2 text-slate-300 text-sm font-medium">
          <Network size={15} className="text-accent" />
          Mapa de infraestructura MP
        </div>
      </div>
      <MpMap autoLoad={true} />
    </div>
  );
}
